import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function GuidesSection() {
  const { t } = useTranslation();

  return (
    <section id="guides" className="relative bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="text-center">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            {t("guides.title")}
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm text-foreground-600 md:text-base">
            {t("guides.subtitle")}
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/${article.slug}`}
              className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative h-44 w-full overflow-hidden bg-background-100">
                <img
                  src={article.image}
                  alt={t(`article.${article.slug}.title`)}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <span className="text-xs font-semibold uppercase tracking-wide text-primary-600">
                  {t(`article.${article.slug}.category`)}
                </span>
                <h3 className="mt-2 font-heading text-lg font-semibold leading-snug text-foreground-950">
                  {t(`article.${article.slug}.title`)}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                  {t(`article.${article.slug}.subtitle`)}
                </p>
                <div className="mt-4 flex items-center justify-between text-sm">
                  <span className="text-xs text-foreground-400">
                    {t("article.updated")} {article.updated}
                  </span>
                  <span className="flex items-center gap-1 font-semibold text-primary-600">
                    {t("guides.readMore")}
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-arrow-right-line text-sm"></i>
                    </span>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}